import { AbstractControl, ValidatorFn } from '@angular/forms';

export const DigitsValidator = (positiveOnly = false): ValidatorFn => {
  const regex = positiveOnly
    ? RegExp(/(^0(([,.]?)\d)\d*$)|(^[1-9]+\d*(([,.]?)\d)\d*$)|(^\d+$)/)
    : new RegExp(/^[-]?(0(([,.]?)\d)\d*$)|(^[-]?[1-9]+\d*(([,.]?)\d)\d*$)|(^[-]?\d+$)/);

  return (control: AbstractControl): { [key: string]: boolean } => {
    if (control?.value && !regex.test(control.value)) {
      return positiveOnly
        ? {
            digitsPositive: true,
          }
        : {
            digits: true,
          };
    }
    return null;
  };
};
